<template>
  <div>
    <el-upload :file-list="picList" :class="picList.length<maxLength ? '':'upload-hide'" :headers='headers'
      :action="'/api/guard/common/file/upload/url'" list-type="picture-card" :on-success="uploadSuccess"
      :on-error="uploadError" :before-upload="beforeUpload" :on-preview="handlePictureCardPreview"
      :on-remove="removePic" :limit='maxLength' :disabled="disabled_">
      <i class="el-icon-plus"></i>
    </el-upload>
    <div v-if="dialogVisible" class="modal" @click.stop="dialogVisible = false;">
      <img :src="imageUrl" alt="" class="big-img">
    </div>

  </div>
</template>

<script>
  export default {
    name: "urlUpload",
    props: {
      filesArr: {
        //编辑回显时必须
        type: Array,
        default: () => []
      },
      maxLength: { //最大上传数量
        type: Number,
        default: 5
      },
    },
    watch: {
      filesArr(val) {
        this.picList = this.filesArr;
      }
    },
    data() {
      return {
        disabled_: false,
        imageUrl: "",
        dialogVisible: false,
        picList: [], //存图片相关的内容
        headers:{
          'AccessTokenE':localStorage.getItem('accessTokenE'),
          'ClientAuth':"Basic eGN3c19yZXBvcnRfd2ViOnhjd3NfcmVwb3J0X3dlYl9zZWNyZXRzZGY="
        }
      }
    },
    methods: {
      //图片上传前
      async beforeUpload(file) {
        return new Promise(async (resolve, reject) => {
          this.disabled_ = true;
          if (["image/png", "image/jpg", "image/jpeg", "image/gif"].indexOf(file.type) == -1) {
            this.$message.error("请选择png、jpg、gif格式的图片！");
            this.disabled_ = false;
            return reject(false);
          }
          if (file.size > 10485760) {
            this.$message.error("上传失败、每张图片大小最多10M！");
            this.disabled_ = false;
            return reject(false);
          }
          return resolve(true)
        })
      },
      //图片上传成功
      uploadSuccess(response, file) {
        this.picList.push({
          name: file.name,
          fileId: Math.random(),
          url: response.data.fileUrl
        });
        this.$message.success("图片上传成功！");
        this.disabled_ = false;
        this.$emit('uploadSuccess', this.picList, '上传成功')
      },
      //图片上传失败
      uploadError(err, file) {
        //   console.log(err, file, "uploadError");
        this.$message.error("图片上传失败！");
        this.disabled_ = false;
        this.$emit('uploadError', this.picList, '上传失败')
      },
      //点击已上传的文件链接
      handlePictureCardPreview(file) {
        //   console.log(file, "handlePictureCardPreview");
        this.imageUrl = file.url;
        this.dialogVisible = true;
      },
      //删除图片
      removePic(file) {
        //   console.log(file, "removePic");
        const url = file.url;
        for (let i = 0; i < this.picList.length; i++) {
          let obj = this.picList[i];
          if (obj.url == url) {
            this.picList.splice(i, 1);
            break;
          }
        }
        this.$emit('remove', this.picList, '删除')
      },
    },
    mounted() {
      this.picList = this.filesArr;
    }
  };
</script>

<style lang='scss'>
  .modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 990;
    display: flex;
    justify-content: center;
    align-items: center;

    .big-img {
      min-width: 30%;
      max-width: 800px;
      max-height: 500px;
    }
  }

  .upload-hide .el-upload {
    display: none;
  }
</style>